import React from 'react';
import { auditStages } from '../../mock';
import { ShieldCheck } from 'lucide-react';

export default function AuditEngine() {
  return (
    <section className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16 items-end">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-white/50 mb-4">
              <ShieldCheck className="w-3.5 h-3.5 text-[#4ECDC4]" />
              <span>Lead Quality</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              Audit Engine <span className="font-serif italic font-normal text-white/50">v2.0</span>
            </h2>
          </div>
          <div className="lg:col-span-3 lg:col-start-8">
            <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">Total checks</div>
            <div className="text-6xl font-medium tabular tracking-tight">18</div>
          </div>
          <div className="lg:col-span-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-1">Stages</div>
            <div className="text-6xl font-medium tabular tracking-tight text-[#4ECDC4]">04</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {auditStages.map((s, i) => (
            <div key={s.stage} className="bg-[#12234C] border border-white/10 rounded-2xl p-8 hover:border-[#4ECDC4] transition-colors duration-300 reveal" style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="flex items-center justify-between mb-6">
                <div className="text-[10px] font-mono uppercase tracking-widest text-[#4ECDC4]">{s.stage}</div>
                <span className="text-xs font-mono text-white/40">{s.checks.length} CHECKS</span>
              </div>
              <h3 className="text-2xl font-medium mb-6 tracking-tight">{s.title}</h3>
              <ul className="space-y-3">
                {s.checks.map((c) => (
                  <li key={c} className="flex items-start gap-2 text-[13px] text-white/80">
                    <span className="w-1 h-1 rounded-full bg-[#4ECDC4] mt-2 shrink-0" />
                    <span>{c}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
